// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1S-UH","empty":"ModalGraph_empty__2UoYA"};